import { HStack, Text } from '@chakra-ui/react';
import type { MarqueeProps } from '@time-line/components/common';
import { Marquee } from '@time-line/components/common';
import type { ReviewsCarousel } from 'types/cms/blocks';

interface ReviewsMarqueeProps extends MarqueeProps {
  reviews: ReviewsCarousel['reviews'];
  hasFade?: boolean;
}

const CLIP_WIDTH = 30;

export function ReviewsMarquee({
  reviews,
  hasFade,
  ...props
}: ReviewsMarqueeProps) {
  return (
    <Marquee
      className="reviews-marquee"
      speed={50}
      clipGradientWidth={hasFade ? CLIP_WIDTH : 0}
      {...props}
    >
      {reviews.map((review, i) => (
        <HStack key={i} spacing="4xs" px="3xs">
          <Text as="h2" size="overline">{`“${review.title}”`}</Text>
          <Text size="body3" color="blackAlpha.700">
            ·
          </Text>
          <Text size="overline" color="blackAlpha.700">
            {`${review.firstName} ${review.lastName}`}
          </Text>
        </HStack>
      ))}
    </Marquee>
  );
}
